module.exports = __webpack_public_path__ + "img/mini-010.3be1c3c1.jpg";